import { useQuery } from "react-query";
import { getAllKnownVisitors } from "../services/VisiterApi";
const useKnownVisitors = () => {
  return useQuery("visitors", getAllKnownVisitors);
};

export default useKnownVisitors;
